<div class="text-sm xl:text-xl 2xl:text-2xl xl:font-semibold relative text-gray-500 mb-4 2xl:mb-6"
  [class.title-fancy]="mode==='fancy'" [class.has-scroll]="isHavingScroll" [class.no-events]="!upcomingEvents.length">
  <div class="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-[transparent] to-[black] opacity-80"
    [class.hidden]="mode==='normal'">
  </div>
  <div class="w-full" [class.absolute]="mode==='fancy'" [class.top-16]="mode==='fancy'"
    [class.text-white]="mode==='fancy'">Other Upcoming Events</div>
</div>

<div #container class="upcoming-events-wrapper overflow-y-auto relative" [class.normal-max-h]="mode==='normal'"
  [class.pr-4]="mode==='normal'" [class.fancy-max-h]="mode==='fancy'">
  <div *ngIf="isLoading" class="loading-wrap">
    <ig-spinner class="vertical-middle"></ig-spinner>
  </div>

  <div *ngIf="!isLoading&&upcomingEvents&&!upcomingEvents.length" class="w-[80%] overflow-hidden m-auto">
    <ig-no-content textCls="text-3xl"></ig-no-content>
  </div>

  <div *ngIf="upcomingEvents?.length" class="upcoming-events" [class.one-column]="true">
    <div *ngFor="let e of upcomingEvents">
      <ig-visitor-modern-block *ngIf="mode==='normal'" [item]="e" [allItems]="allEvents" [isSimple]="true"
        (onClick)="upcomingEventClick()"></ig-visitor-modern-block>

      <div *ngIf="mode==='fancy'" class="rounded-3xl shadow-lg mx-10 mb-3 cursor-pointer"
        (click)="upcomingEventClick(e)">
        <ig-image [src]="e.cover?.source" class="block overflow-hidden"
          cls="aspect-[3/2] w-full rounded-t-3xl transition-all hover:scale-[1.05]"></ig-image>
        <div class="px-6 py-4 bg-white rounded-b-3xl">
          <div class="text-sm font-semibold text-gray-600 mb-1 -mt-1">{{e.name}}</div>
          <div class="text-xs text-gray-500">
            <span>{{e.timeTwoLines?.date}}</span>
            <span *ngIf="e.eventTimes.length>1||e.timeTwoLines?.time" class="mx-2">·</span>
            <span>{{e.eventTimes.length>1?'Multiple times':e.timeTwoLines?.time}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="!isLoading">
  <ig-button *ngIf="mode==='normal'" [class.upper-btn]="upcomingEvents.length===1||upcomingEvents.length===2"
    cls="w-[calc(100%-16px)] mt-4" size="md" class="btn-cancel" (trigger)="more()">Explore more
    events
  </ig-button>

  <div *ngIf="mode==='fancy'"
    class="mx-10 py-2 text-center bg-white relative -top-6 text-base rounded-3xl transition-all shadow-lg hover:shadow-xl cursor-pointer text-gray-600 font-semibold"
    (click)="more()" [class.has-scroll]="isHavingScroll">
    Back to All Events</div>
</ng-container>
